<template>
  <div class="min-h-screen bg-gray-50 pb-28" dir="rtl">
    <div class="bg-white border-b border-gray-200 sticky top-0 z-20">
      <div class="max-w-2xl mx-auto px-4 py-3 flex items-center gap-3">
        <img
          :src="user_image || '/img/avatar.jpg'"
          alt=""
          class="w-10 h-10 rounded-full object-cover border border-gray-200 flex-shrink-0"
        />
        <div class="flex-1 min-w-0">
          <p class="text-sm font-bold text-gray-900 truncate">{{ $t('savedMessage') }}</p>
          <p class="text-xs text-gray-500">{{ $t('online') }}</p>
        </div>
        <button
          type="button"
          class="w-9 h-9 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center transition-colors"
          @click="backToChats()"
        >
          <chat-icon name="arrow-left" color="#111" />
        </button>
      </div>
    </div>

    <div
      class="chat-text max-w-2xl mx-auto px-4 pt-4"
      id="chat_detail"
      v-chat-scroll="{always: false}"
      style="height: calc(100vh - 160px); overflow-y: auto; background-image: url('/img/chat_back.svg');"
    >
      <infinite-loading @infinite="infiniteHandler" direction="top">
        <div slot="no-more"></div>
      </infinite-loading>

      <div class="space-y-3 pb-24">
        <div v-for="(chat, index) in chatLoad" :key="chat.InboxItemId || index">
          <div
            v-if="chat.UserSenderName != UserName"
            class="flex justify-start"
          >
            <div class="max-w-80% bg-white border border-gray-200 rounded-2xl rounded-tr-md px-3 py-2 shadow-sm">
              <p class="text-sm text-gray-900 whitespace-pre-wrap leading-6">{{ chat.MessageText }}</p>
              <p class="text-10px text-gray-400 mt-1 text-left">دیروز 12:55</p>
            </div>
          </div>

          <div
            v-if="chat.UserSenderName == UserName"
            class="flex justify-end"
          >
            <div class="max-w-80% bg-blue-600 text-white rounded-2xl rounded-tl-md px-3 py-2 shadow-sm">
              <p class="text-sm whitespace-pre-wrap leading-6">{{ chat.MessageText }}</p>
              <div class="flex items-center justify-end gap-1 mt-1">
                <chat-icon name="check-all" color="#dbeafe" />
                <span class="text-10px text-blue-100">دیروز 12:55</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="fixed bottom-16 left-0 right-0 z-20 px-4 pb-3">
      <div class="max-w-2xl mx-auto bg-white border border-gray-200 rounded-2xl shadow-sm px-3 py-2 flex items-center gap-2">
        <button type="button" class="w-9 h-9 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0">
          <chat-icon name="plus" color="#374151" />
        </button>
        <input
          class="flex-1 min-w-0 bg-transparent text-sm text-gray-900 outline-none placeholder-gray-400"
          :placeholder="$t('message')"
        />
        <button type="button" class="w-9 h-9 rounded-full bg-blue-600 text-white flex items-center justify-center flex-shrink-0">
          <chat-icon name="send" color="#fff" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import InfiniteLoading from 'vue-infinite-loading'
  import ChatIcon from '../../components/chat/ChatIcon.vue'

  export default {
    data () {
      return {
        items:'',
        UserId: '',
        chat: [],
        password: '',
        up: 0,
        lastMessageId : 0,
        UserName: '',
        chats: [],
        user_info: '',
        first: true,
        chatLoad: [],
        user_image: ''
      }
    },
    components: {
      InfiniteLoading,
      ChatIcon,
    },
    methods: {
      infiniteHandler ($state) {
        var self = this
        if (this.first) {
          setTimeout(() => {
            $state.loaded()
          }, 1000)
          return false
        }

        setTimeout(() => {
          self.lastMessageId = self.chatLoad[0].InboxItemId
          self.loadChats($state)
        }, 1000)
      },
      backToChats () {
        this.$router.go(-1)
      },
      loadChats ($state) {
        var user_data = JSON.parse(localStorage.getItem('profile'))
        this.user_image = user_data.ThumbPath
        const send_data = {
          ReceiverId:this.UserId,
          UserId: this.UserId,
          RecType: this.items.RecType,
          LastMessageId: this.lastMessageId,
          Password: this.password,
        }
        var self = this
        this.axios.post('/LoadContactChats', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              console.log('response edit', response.data.messages)
              self.chats = response.data.messages

              self.chats.reverse()
              if (self.first) {
                self.first = false
                self.chatLoad = self.chats
              } else {
                self.chats.reverse()
                for (var i = 0; i < self.chats.length; i++) {
                  self.chatLoad.splice(0, 0, self.chats[i])
                }
              }
              if ($state != null) {
                if (self.chats.length > 0) {
                  $state.loaded()
                } else {
                  $state.complete()
                }
              }
            }
          }).catch(e => {

        })
      },
      getUserInfo () {
        const send_data = {
          UserId:this.items.UserOrGroupId
        }
        var self = this
        this.axios.post('/GetUserInfo', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              self.user_info = response.data.userInfo
            }
          }).catch(e => {

        })
      },
      getGroupInfo () {

      },
      scrollToEnd () {
        var container = this.$el.querySelector('#chat_detail')
        var pageHeight = container.scrollHeight
        container.scrollTop = pageHeight
      },
      someMethod () {
        this.$socket.invoke('socketName', payloadData)
          .then(response => {
          })
      },

      async someAsyncMethod () {
        const response = await this.$socket.invoke('socketName', payloadData)
      }
    },
    mounted () {
      var user_data = JSON.parse(localStorage.getItem('profile'))
      this.password = localStorage.getItem('password')
      this.UserId = user_data.UserId
      this.UserName = user_data.UserName
      this.items = JSON.parse(localStorage.getItem('lastChat'))
      this.loadChats()
      if (this.items.RecType == 0) {
        this.getUserInfo()
      } else {
        this.getGroupInfo()
      }
      this.scrollToEnd()
    },
  }
</script>
